import styled from 'styled-components';

export const OrderMainWrap = styled.div<{ rtl?: boolean }>`
  .bl-signUp-text {
    text-align: center;
    font-weight: 500;
    font-size: 30px;
    line-height: 45px;
    margin-top: 20px;
    margin-bottom: 88px;
  }

  .bl-ticket-main-wrap {
    margin-left: 163px;
    margin-right: 220px;
    display: flex;

    .bl-tickets-wrap {
      margin-right: ${({ rtl }) => `${rtl ? 'initial' : '16px'}`};
      margin-left: ${({ rtl }) => `${rtl ? '16px' : 'initial'}`};
      width: calc(50% - 16px);
      display: inline-block;

      .bl-add-ticket-wrap {
        margin-top: 15px;
        display: flex;
        align-items: baseline;
        cursor: pointer;

        &:active {
          opacity: 0.8;
        }

        .bl-add-plus {
          width: 21px;
          height: 21px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ea475c;
          border-radius: 2px;
          color: white;
        }

        .bl-add-text {
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          margin-left: 10px;
          ${({ rtl }) => `${rtl ? 'margin: 0 10px;' : ''}`};
        }
      }
    }
  }

  .bl-payment-wrap {
    height: 466px;
    width: 582px;
    margin: auto;
    cursor: pointer;
  }

  .ch-btn {
    text-align: center;
    margin-top: 37px;
  }

  @media screen and (max-width: 760px) {
    .bl-steps-widget {
      margin-top: 0;
    }

    .bl-signUp-text {
      margin-bottom: 0;
    }

    .bl-ticket-main-wrap {
      display: flex;
      flex-direction: column;
      margin: 15px 22px;

      .bl-ticket-order {
        width: 100%;
        padding: 15px;

        .bl-ticket-order-pills {
          margin-bottom: 14px;

          .bl-ticket-order-pill {
            margin-bottom: 8px;
          }
        }

        .bl-ticket-order-pay-btn {
          padding: 12px;
          width: 100%;
        }
      }

      .bl-tickets-wrap {
        width: 100%;
        margin-bottom: 20px;
        margin-right: 0;

        .bl-ticket-item {
          position: relative;
          display: flex;
          width: 100%;

          .bl-ticket-desc {
            width: 83px;
            min-width: 83px;
          }

          .bl-ticket-data {
            padding: 9px 17px 18px 14px;
            overflow: hidden;
            //width: auto;
            width: 100%;
            padding-right: 27px;

            .bl-field-1 {
              margin-top: 12px;
            }

            .bl-field-2 {
              margin-top: 21px;
            }

            .bl-field-1,
            .bl-field-2 {
              label {
                position: relative;
              }

              span {
                line-height: 1;
                position: absolute;
                background: white;
                top: -12px;
                left: 12px;
              }

              input {
                height: 30px;
                width: 100%;
              }
            }
          }
        }
      }
    }

    .bl-payment-wrap {
      max-width: 100%;

      img {
        max-width: 100%;
        object-fit: cover;
      }
    }
  }

  @media screen and (min-width: 1057px) and (max-width: 1440px) {
    .bl-ticket-main-wrap {
      width: 1057px;
      margin: auto;
    }
  }
  @media screen and (min-width: 760px) and (max-width: 1057px) {
    .bl-ticket-main-wrap {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 519px;
      margin: auto;

      .bl-tickets-wrap {
        width: 100%;
      }

      .bl-ticket-order {
        width: 100%;
      }
    }
  }
  @media screen and (min-width: 1440px) {
    .bl-ticket-main-wrap {
      max-width: 1080px;
      margin: auto;
    }
  }
`;
